import * as React from "react";
import { Box, Button, Typography } from "@mui/material";
import { useTheme } from "@mui/material";
import { alpha } from "@mui/material";
import { useNavigate } from "react-router";
import { dashboardRoute } from "../../routes/reactRoutes";
import { LockPersonOutlined } from "@mui/icons-material";
import { t } from "i18next";

export default function UnAuthorized() {
  //styling
  const theme = useTheme();
  const navigate = useNavigate();
  const divStyle = {
    display: "flex",
    p: 2,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    boxSizing: "border-box",
    background: alpha(theme.palette.primary.main, 0.15),
  };

  //end styling
  const handleHomePageClick = () => {
    navigate(dashboardRoute);
  };

  return (
    <Box sx={divStyle}>
      <LockPersonOutlined
        color="primary"
        sx={{ width: "200px", height: "200px" }}
      ></LockPersonOutlined>
      <Typography sx={{ fontSize: "2rem", color: theme.palette.primary.main }}>
        {t("unauthorized")}
      </Typography>
      <Typography
        sx={{ fontWeight: 400, mb: 2.5, color: theme.palette.primary.main }}
      >
        {t("nopermission")}
      </Typography>
      <Button
        variant="contained"
        onClick={handleHomePageClick}
        sx={{ width: "300px", textTransform: "none", fontSize: 18 }}
      >
        {t("gohomepage")}
      </Button>
    </Box>
  );
}
